<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/" class="Breadcrumb">展覽列表</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>代理申請
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <div>
      <!-- article -->
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span class="font-weight-bold text-primary" style="font-size: 16px" v-if="item.MenuName == '代理申請'">
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>

        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/iconProxy.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="MbDevice">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div>
                    <img src="@/assets/images/iconProxy.svg" width="35px" class="mt-1 mr-1" />
                  </div>
                  <div>
                    <h1>代理申請</h1>
                  </div>
                </div>

                <!-- <div>
                  <h1><img src="@/assets/images/iconProxy.svg" width="35px" class="mb-2" /> 代理申請</h1>
                </div> -->
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                        <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>代理申請</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            <p>
              您可以幫重要的客戶代理申請參觀資格，填入受邀客戶之Email後，系統將自動為您寄出邀請Email；受邀客戶依照Email指示，完成參觀資格申請後，即可於展期憑「入場憑證
              QR Code」入場參觀。
            </p>
            <p class="my-3">&nbsp;</p>
            <ol class="number">
              <li>額度有限，請斟酌使用</li>
              <li>被登錄之客戶完成免費參觀資格開通後即列入額度使用計算</li>
              <li>申請開放至展期最後一天展覽結束截止</li>

              <!-- <li>申請開放至展期最後一天 <span class="red"><span name="ExhEnd"></span> 17:00</span> 前截止</li> -->
            </ol>
            <p class="my-3">&nbsp;</p>

            <div v-if="!hasAccountId">
              <div class="alert alert-danger" role="alert">
                <img src="@/assets/images/tickGray.svg" width="16px" class="mb-1 mr-1" alt="" />
                專屬邀請代碼異常，請洽大會業務人員。
              </div>

              <h3 class="mt-4 mb-3">大會業務聯絡窗口</h3>
              <div name="ExpoContact"></div>
            </div>

            <div v-else>
              <p>
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/inviteProxyApply?no=${RegNo}&d=1`"
                  data-fancybox
                  data-type="iframe"
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  name="btnOneDay"
                  class="btnStyle iframeForm mr-2"
                  >1日申請</a
                >
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/inviteProxyApply?no=${RegNo}&d=4`"
                  data-fancybox
                  data-type="iframe"
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  name="btnFourDay"
                  class="btnStyle iframeForm"
                  >4日申請</a
                >
              </p>

              <p class="lightLine">&nbsp;</p>
              <h3>查看登錄狀況</h3>
              <p class="my-3">&nbsp;</p>

              <div class="grayBG mr-3">
                <p class="bold">1日代理申請</p>
                <p class="divider"></p>
                <p>
                  已使用名額：<span class="red" name="TotalInvUsed_1"></span> / <span name="InvitationQuota_1"></span>
                </p>
                <p>已完成登錄人數：<span class="red" name="TotalMember_1"></span></p>
                <p>已報到人數：<span class="red" name="TotalVisitor_1"></span></p>
                <p class="divider"></p>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/inviteProxyList?no=${RegNo}&d=1`"
                    data-fancybox
                    data-type="iframe"
                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                    class="link iframeForm linkstyle"
                    >詳細資料</a
                  >
                </p>
              </div>

              <div class="grayBG mt-3">
                <p class="bold">4日代理申請</p>
                <p class="divider"></p>
                <p>
                  已使用名額：<span class="red" name="TotalInvUsed_4"></span> / <span name="InvitationQuota_4"></span>
                </p>
                <p>已完成登錄人數：<span class="red" name="TotalMember_4"></span></p>
                <p>已報到人數：<span class="red" name="TotalVisitor_4"></span></p>
                <p class="divider"></p>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/inviteProxyList?no=${RegNo}&d=4`"
                    data-fancybox
                    data-type="iframe"
                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                    class="link iframeForm linkstyle"
                    >詳細資料
                    <i class="fas fa-external-link-alt ml-2 text-primary" style="font-size: 15px"></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <p class="clear"></p>
        </div>
      </article>
      <!-- article end -->
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: '代理申請 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        CSRF_Token: '',
        RegNo: '',
        Type: '',
        E_Lang: 'tw',
        ClientEmail: '',
        lang: 'tw',
        hasAccountId: true,
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },

    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },
      closefancybox() {
        parent.$.fancybox.close()
      },

      submitInvitation() {
        const vm = this

        const url = '/apiExhibitors/ClientInvitation/'

        const info = {
          RegNo: vm.RegNo,
          Type: vm.Type,
          E_Lang: vm.E_Lang,
          ClientEmail: vm.ClientEmail,
          CSRF: vm.CSRF_Token,
        }

        // console.log(info)

        if (vm.lang == 'tw') {
          if (!vm.ClientEmail) {
            alert('輸入欄位不完整，請重新檢查！')
          } else {
            axios.post(url, info).then(function (response) {
              // console.log(response)
              if (response.data.Code == 200) {
                alert(`代理申請信已寄至您填寫的信箱 \n ${vm.ClientEmail}`)
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('您輸入的Email有誤！')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              } else if (response.data.Code == 253) {
                alert('您輸入的Email有誤！')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 254) {
                alert('您填入的Email已有參觀資格！')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 255) {
                alert('超過代理登錄額度！')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 256) {
                alert('您已過代理申請時間！')
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        } else {
          if (!vm.ClientEmail) {
            alert('There are incomplete fields, please check again.')
          } else {
            axios.post(url, info).then(function (response) {
              // console.log(response)
              if (response.data.Code == 200) {
                alert(`Client registration has been sent to your email! \n ${vm.ClientEmail}`)
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              } else if (response.data.Code == 253) {
                alert('Invalid email, please check again.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 254) {
                alert('The email you entered already have admission.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 255) {
                alert('You have reached the limited amount quota!')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 256) {
                alert('Client registration is closed! ')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        }
      },
    },

    created() {
      const vm = this

      //取得語系

      let lang = 'tw'

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })
      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      //判斷是否有AccountID
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response.data.Data)

        let AccountID = response.data.Data.AccountID

        if (!AccountID) {
          vm.hasAccountId = false

          $.getJSON('/apiExhibitors/ExpoContact/' + vm.RegNo + '?lang=' + lang, function (data) {
            $('[name="ExpoContact"]').html(data.Data.ExpoContact)
          })
        } else {
          vm.hasAccountId = true
        }
      })

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data.Data)

          vm.MenuInvitation = response.data.Data
        })

      $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
        $('[name="ExhEnd"]').text(data.Data.ExhEnd)

        //當前時間 Timestamp
        var currentdate = Date.parse(new Date()).valueOf()
        // console.log(currentdate)

        //設定畢展時間 Timestamp
        var CloseDay = new Date(data.Data.ExhEnd)
        CloseDay.setDate(CloseDay.getDate())
        //6點前關閉
        var ExhTime = Date.parse(CloseDay) + 64800000
        // console.log(ExhTime)

        if (currentdate > ExhTime) {
          if (lang == 'tw') {
            $('.btnStyle').addClass('btnExpire')
          } else {
            $('.btnStyle').addClass('ebtnExpire')
          }
        }
      })

      //InvTotal
      $.getJSON('/apiExhibitors/InvTotal_Quota/' + vm.RegNo, function (data) {
        //InvTotal
        $('[name="InvitationQuota_1"]').text(data.Data.InvitationQuota_1)
        $('[name="InvitationQuota_4"]').text(data.Data.InvitationQuota_4)
        $('[name="TotalInvUsed_1"]').text(data.Data.TotalInvUsed_1)
        $('[name="TotalInvUsed_4"]').text(data.Data.TotalInvUsed_4)

        $('[name="TotalMember_1"]').text(data.Data.TotalMember_1)
        $('[name="TotalMember_4"]').text(data.Data.TotalMember_4)
        $('[name="TotalVisitor_1"]').text(data.Data.TotalVisitor_1)
        $('[name="TotalVisitor_4"]').text(data.Data.TotalVisitor_4)

        //判斷是否額滿
        if (data.Data.InvitationQuota_1 == data.Data.TotalInvUsed_1) {
          if (lang == 'tw') {
            $('[name="btnOneDay"]').addClass('btnFull')
          } else {
            $('[name="btnOneDay"]').addClass('ebtnFull')
          }
        }
        if (data.Data.InvitationQuota_4 == data.Data.TotalInvUsed_4) {
          if (lang == 'tw') {
            $('[name="btnFourDay"]').addClass('btnFull')
          } else {
            $('[name="btnFourDay"]').addClass('ebtnFull')
          }
        }
      })
    },
  }
</script>

<style lang="scss">
  a:hover {
    color: #ffffff;
    text-decoration: none;
  }

  .linkstyle:hover {
    color: #0056b3;
  }

  .alert-danger {
    background-color: #f8d7da;
  }

  .alert {
    padding: 10px 10px;
    font-size: 15px;
  }

  .Breadcrumb:hover {
    color: #3153f8db;
  }
</style>
